import PropTypes from 'prop-types';

const careersType = PropTypes.arrayOf(
  PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    reason: PropTypes.string,
  }),
);

export default careersType;
